import React from 'react'

const Banner2 = () => {
  return (
   <section className="banner-section banner--five" style={{backgroundImage: 'url(/assets/images/bg-1.png)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
  <div className="container-fluid" style={{backgroundColor: 'rgba(3, 59, 12, 0.68)'}}>
    <div className='container'>
    <div className="row">
      <div className="col-lg-12">
        <div className="banner-content-area">
          <div id="particles-js" style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, zIndex: -1}} />
          <div className="banner-content text-center">
            <h2 className="banner-title" style={{color: '#fff', fontWeight: 'bolder', paddingTop: '50px'}}>Your First Steps Into The Financial Markets Investment</h2>
            <a style={{backgroundColor: '#ff0000', color: '#ffffff', fontWeight: 'bolder'}} href="https://account.fx-globals.com" className="btn btn-round">Get Started Now</a>
            <div className="banner-thumb anim-bounce">
              <img src="assets/images/elements/home3-banner.png" alt="image" />
              </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</section>

  )
}

export default Banner2
